<template lang="pug">
v-layout(column)
  v-subheader.mt-2 {{ $tf("settings.profile.title") }}

  v-layout(row :class="{ 'px-3 pt-2' : $vuetify.breakpoint.smAndUp}")
    v-flex(md4 lg4 xl3)
      v-card(width="100%")
        v-img(height="280" src="/static/icons/background_01.png")
          v-layout(column align-center justify-center).mt-3
            v-avatar(size="64")
              img.profile-avatar(v-if="profile.photo" :src="'data:image/png;base64,' + profile.photo")
              img(v-else src="/static/icons/avatar.png")
            .headline.white--text.mt-3 {{profile.firstName}} {{profile.lastName}}
        v-card-text.pa-0
          v-tabs
            v-tab(ripple href="#tab-1")
              | {{ $tf("settings.profile.info") }}
            //v-tab(ripple href="#tab-2")
              | {{ $tf("settings.profile.groups") }}
            v-tabs-items
              v-tab-item(value="tab-1")
                v-card(flat)
                  v-card-text
                    v-list.pa-0(two-line)
                      v-list-tile(v-if="profile.phone")
                        v-list-tile-action
                          v-icon(color="indigo") phone
                        v-list-tile-content
                          v-list-tile-title {{profile.phone}}
                          v-list-tile-sub-title {{ $tf("settings.profile.phone") }}
                      //v-divider(inset)
                      v-list-tile(v-if="profile.email")
                        v-list-tile-action
                          v-icon(color="indigo") mail
                        v-list-tile-content
                          v-list-tile-title {{profile.email.replace('@kazzinc.com','')}}
                          //v-list-tile-sub-title {{ $tf("settings.profile.email") }}
              //v-tab-item(value="tab-2")
                v-card(flat)
                  v-card-text
                    v-list.pa-0
                      template(v-for="(group, index) in groups")
                        v-list-tile
                          v-list-tile-action
                            v-icon(color="indigo") person
                          v-list-tile-content
                            v-list-tile-sub-title.ws-n {{group.name}}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsProfile',

  data() {
    return {
    }
  },

  computed: {
    ...mapGetters({
      profile: 'auth/profile',
      groups: 'auth/groups',
    }),
  },

  methods: {
  },
}
</script>

<style lang="stylus">
.profile-avatar
  border 2px #fff solid
.ws-n
  white-space normal
.lang-icon
  width 24px
</style>



// WEBPACK FOOTER //
// src/components/settings/SettingsProfile.vue